import templates from './templates';

export function generatePath(template, params = {}) {
  if (!template) return template;
  let result = template || '';
  for (var key in params) {
    result = result.replace(`:${key}?`, params[key]);
    result = result.replace(`:${key}`, params[key]);
  }
  return result;
}

const profile = ({ id } = {}) => generatePath(templates.users.profile, { id });
const vanityProfile = ({ username } = {}) =>
  generatePath(templates.users.vanityProfile, { username });
const bestProfile = ({ user, isCurrentUser = false }) => {
  return (
    (user &&
      (user.username
        ? vanityProfile({ username: user.username })
        : user.id ? profile({ id: user.id }) : isCurrentUser ? templates.users.myProfile : null)) ||
    undefined
  );
};

// TODO: Convert this to babel plugin to autoGenerate
export default {
  users: {
    profile,
    vanityProfile,
    bestProfile,
  },
  admin: {
    badges: {
      edit: ({ prettyId }) => generatePath(templates.admin.badges.edit, { prettyId }),
    },
    jobs: {
      edit: ({ id }) => generatePath(templates.admin.jobs.edit, { id }),
      applicants: ({ id }) => generatePath(templates.admin.jobs.applicants, { id }),
      referrals: ({ id }) => generatePath(templates.admin.jobs.referrals, { id }),
    },
    assignments: {
      edit: ({ id }) => generatePath(templates.admin.assignments.edit, { id }),
    },
    preassess: {
      edit: ({ id }) => generatePath(templates.admin.preassess.edit, { id }),
    },
    behavassess: {
      edit: ({ id }) => generatePath(templates.admin.behavassess.edit, { id }),
    },
    skills: {
      edit: ({ name }) => generatePath(templates.admin.skills.edit, { name }),
    },
    validators: {
      details: ({ validator_id }) =>
        generatePath(templates.admin.validators.details, { validator_id }),
      update: ({ validator_id }) =>
        generatePath(templates.admin.validators.update, { validator_id }),
    },
    claims: {
      root: ({ search, source, stage, page, perPage, sort }) => {
        const params = new URLSearchParams();
        if (search) params.set('search', search);
        if (source) params.set('source', source);
        if (stage) params.set('stage', stage);
        if (page) params.set('page', page);
        if (perPage) params.set('per-page', perPage);
        if (sort) params.set('sort', sort);
        return `${templates.admin.claims.root}?${params.toString()}`;
      },
    },
    features: {
      edit: ({ id }) => generatePath(templates.admin.features.edit, { id }),
    },
    profiler: {
      details: ({ id, section }) => generatePath(templates.admin.profiler.details, { id, section }),
    },
  },

  profiler: {
    details: ({ id, section }) => generatePath(templates.profiler.details, { id, section }),
    inviteCandidateToChatbots: ({ profilerRunId, profilerCandidateId }) =>
      generatePath(templates.profiler.inviteCandidateToChatbots, {
        profilerRunId,
        profilerCandidateId,
      }),
  },
  claims: {
    details: ({ id }) => generatePath(templates.claims.details, { id }),
    detailsViewPdf: ({ id }) => generatePath(templates.claims.detailsViewPdf, { id }),
  },
  claimReports: {
    details: ({ reportId }) => generatePath(templates.claimReports.details, { reportId }),
  },
  chatbotReports: {
    details: ({ profilerCandidateId }) =>
      generatePath(templates.chatbotReports.details, { profilerCandidateId }),
  },
  votes: {
    cast: ({ claimId, voteId }) => generatePath(templates.votes.cast, { claimId }),
  },
  companies: {
    vanityProfile: ({ prettyId }) => generatePath(templates.companies.vanityProfile, { prettyId }),
    acceptAsAdvisor: ({ prettyId, advisoryId }) =>
      generatePath(templates.companies.acceptAsAdvisor, {
        prettyId,
        advisoryId,
      }),
    revokeAsAdvisor: ({ prettyId, advisoryId }) =>
      generatePath(templates.companies.revokeAsAdvisor, {
        prettyId,
        advisoryId,
      }),
    acceptAsTeamMember: ({ prettyId, teamMembershipId }) =>
      generatePath(templates.companies.acceptAsTeamMember, {
        prettyId,
        teamMembershipId,
      }),
    revokeAsTeamMember: ({ prettyId, teamMembershipId }) =>
      generatePath(templates.companies.revokeAsTeamMember, {
        prettyId,
        teamMembershipId,
      }),
    softConnectionInviteAcceptRejectLink: ({ prettyId, id }) =>
      generatePath(templates.companies.acceptAdvisorConnection, { prettyId, id }),
    edit: ({ prettyId, section = '' }) =>
      generatePath(templates.companies.edit, { prettyId, section }),
    magicLinkCandidates: ({ prettyId, publicId }) =>
      generatePath(templates.companies.magicLinkCandidates, { prettyId, publicId }),
    hiringDashboard: ({ prettyId }) =>
      generatePath(templates.companies.hiringDashboard, { prettyId }),
  },
  badges: {
    details: ({ prettyId }) => generatePath(templates.badges.details, { prettyId }),
  },
  assignments: {
    details: ({ assignmentId }) => generatePath(templates.assignments.details, { assignmentId }),
  },
  magicLinks: {
    assessmentMagicLink: ({ publicId }) =>
      generatePath(templates.magicLinks.assessmentMagicLink, { publicId }),
  },
  program: {
    behavAssess: ({ publicId }) =>
      generatePath(templates.program.behaviouralAssessment, { publicId }),
  },
  validatorFeatures: {
    details: ({ id }) => generatePath(templates.validatorFeatures.details, { id }),
  },
  codeReviewProof: ({ uuid }) => generatePath(templates.codeReviewProof.root, { uuid }),
  chatbotView: ({ skillName }) => generatePath(templates.chatbotView, { skillName }),
  chatbotQuiz: ({ profilerCandidateId }) =>
    generatePath(templates.chatbotQuiz.quiz, { profilerCandidateId }),
  chatbotQuizSubmission: ({ profilerCandidateId }) =>
    generatePath(templates.chatbotQuiz.quizSubmission, { profilerCandidateId }),
};



// WEBPACK FOOTER //
// ./src/ui/common/routes/generators.js